module.exports = __webpack_public_path__ + "085e80cedca2099743d8c4c5b7332ed6.png";